import { z } from 'zod';
/**
 * Value substituted for merchant secrets (vendor access tokens, GTM Server
 * preview tokens) before an audit envelope is persisted. Secrets are the ONLY
 * thing redacted — cookies and PII are stored verbatim for full audit fidelity.
 */
export const REDACTED = '***REDACTED***';
/**
 * The complete outgoing HTTP request sent to a server-side integration vendor,
 * captured for audit. Stored on `IntegrationEvent.request`.
 *
 * - `cookies` is the raw first-party cookie map (`_ga`, `_fbp`, `_fbc`, `_scid`…).
 *   For Addingwell these are also transmitted in the `Cookie` header; for
 *   Facebook/Snapchat they are the source of cookie-derived IDs placed in `body`.
 * - `query`/`headers` have merchant secrets replaced with {@link REDACTED}.
 * - `body` is the exact JSON payload POSTed (same value mirrored into the
 *   legacy `payload` field).
 */
export const ZIntegrationRequestEnvelope = z.object({
    url: z.string(),
    method: z.literal('POST'),
    query: z.record(z.string(), z.string()).optional(),
    headers: z.record(z.string(), z.string()),
    cookies: z.record(z.string(), z.string()).optional(),
    body: z.unknown(),
});
//# sourceMappingURL=integration-request-envelope.js.map